module.exports = __webpack_public_path__ + "img/email-icon.e38a5f78.svg";